import React, { useState, useEffect } from "react";
import { TableLoader } from "../../../Common/ShimmerLoader";
import ExcelJS from "exceljs";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import { getAllZoneWiseReport } from "../../../Apis/scvReports/reportedSCVApi";
import { Modal } from "react-bootstrap";
import { formatDateTimeWithoutSec, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
import { toast } from "react-toastify";

const SCVDeployedTripsView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { data, fromDate, toDate } = location.state || {};
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const dataPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [scvList, setScvList] = useState(data || []);


  // Set default filter values based on fromDate and toDate
  const getDefaultFilterFields = () => {
    const from = fromDate ? new Date(fromDate) : new Date();
    const to = toDate ? new Date(toDate) : new Date();

    const defaultDate = new Date();
    const minDate = isNaN(from.getTime()) ? defaultDate : from;
    const maxDate = isNaN(to.getTime()) ? defaultDate : to;
const currentDate = new Date();
    const formatDateTime = (date, isStart = true) => {
     const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      if (!isStart && date.toDateString() === currentDate.toDateString()) {
        // Use current time for toDate if it's today
        const hours = String(currentDate.getHours()).padStart(2, "0");
        const minutes = String(currentDate.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}`;
      }
      const hours = isStart ? "00" : "23";
      const minutes = isStart ? "00" : "59";
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    return {
      searchCircle: "",
      searchVehicleNumber: "",
      searchVehicleUID: "",
      searchFromDate: formatDateTime(minDate, true), // e.g., "2025-05-20T00:00"
      searchToDate: formatDateTime(maxDate, false), // e.g., "2025-05-21T23:59"
    };
  };

  // Set min and max for datetime-local inputs
  const from = fromDate ? new Date(fromDate) : new Date();
  const to = toDate ? new Date(toDate) : new Date();

  const defaultDate = new Date();
  const minDateTime = isNaN(from.getTime())
    ? `${defaultDate.getFullYear()}-${String(defaultDate.getMonth() + 1).padStart(2, "0")}-${String(defaultDate.getDate()).padStart(2, "0")}T00:00`
    : `${from.getFullYear()}-${String(from.getMonth() + 1).padStart(2, "0")}-${String(from.getDate()).padStart(2, "0")}T00:00`;
  const maxDateTime = isNaN(to.getTime())
    ? `${defaultDate.getFullYear()}-${String(defaultDate.getMonth() + 1).padStart(2, "0")}-${String(defaultDate.getDate()).padStart(2, "0")}T23:59`
    : `${to.getFullYear()}-${String(to.getMonth() + 1).padStart(2, "0")}-${String(to.getDate()).padStart(2, "0")}T23:59`;

  const parseDeploymentDate = (dateString) => {
    if (!dateString || dateString === "N/A") return null;
    // Assuming format "DD-MM-YYYY HH:MM"
    const [datePart, timePart] = dateString.split(" ");
    if (!datePart || !timePart) {
      console.warn("Invalid deploymentDate format:", dateString);
      return null;
    }
    const [day, month, year] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);
    const date = new Date(year, month - 1, day, hour, minute);
    if (isNaN(date.getTime())) {
      console.warn("Parsed deploymentDate is invalid:", dateString);
      return null;
    }
    return date;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchDataForPage(pageNumber);
  };

  const fetchDataForPage = (pageNumber) => {
    setIsLoading(true);
    getAllZoneWiseReport(fromDate, toDate, "", "")
      .then((response) => {
        const fetchedData = response.data || [];
        setScvList(fetchedData);
        searchReportedAtVehicleHandler(getDefaultFilterFields());
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setScvList([]);
        toast.error("Failed to fetch data");
        setIsLoading(false);
      });
  };

  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle ? values.searchCircle.toLowerCase() : "";
    const termVehicle = values.searchVehicleNumber ? values.searchVehicleNumber.toLowerCase() : "";
    const termVehicleUID = values.searchVehicleUID ? values.searchVehicleUID.toLowerCase() : "";
    const termFromDate = values.searchFromDate ? new Date(values.searchFromDate) : null;
    const termToDate = values.searchToDate ? new Date(values.searchToDate) : null;
    if (termFromDate && termToDate && termToDate < termFromDate) {
      toast.error("To Date must be after From Date");
      return;
    }
    const filteredData =data.filter((item) => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const vehicleNumber = item?.vehicleNumber ? item.vehicleNumber.toLowerCase() : "";
      const vehicleUuid = item?.vehicleUuid ? item.vehicleUuid.toLowerCase() : "";
      const deploymentDate = parseDeploymentDate(item?.deploymentDateFormatted);
      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesVehicle = !termVehicle || vehicleNumber.includes(termVehicle);
      const matchesVehicleUID = !termVehicleUID || vehicleUuid.includes(termVehicleUID);
      const matchesDate =
        !deploymentDate ||
        (!termFromDate && !termToDate) ||
        (termFromDate && !termToDate && deploymentDate >= termFromDate) ||
        (!termFromDate && termToDate && deploymentDate <= termToDate) ||
        (termFromDate && termToDate && deploymentDate >= termFromDate && deploymentDate <= termToDate);

      return matchesCircle && matchesVehicle && matchesVehicleUID 
      // && matchesDate;
    });
    setScvList(filteredData);
  };

  useEffect(() => {
    // Fetch initial data for the first page
    fetchDataForPage(currentPage);
  }, [fromDate, toDate]);
  const scvReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["sno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: "70px",
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => <span>{row["zoneName"] || "N/A"}</span>,
      sortable: true,
      width: "100px",
    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Ward",
      selector: (row) => row["wardName"],
      cell: (row) => <span>{row["wardName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Number</>,
      selector: (row) => row["vehicleNumber"],
      cell: (row) => <span>{row["vehicleNumber"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Type</>,
      selector: (row) => row["vehicleTypeName"],
      cell: (row) => <span>{row["vehicleTypeName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Owner Type</>,
      selector: (row) => row["ownerTypeName"],
      cell: (row) => <span>{row["ownerTypeName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle Capacity</>,
      selector: (row) => row["vehicleCapacityName"],
      cell: (row) => <span>{row["vehicleCapacityName"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Vehicle UID</>,
      selector: (row) => row["vehicleUuid"],
      cell: (row) => <span>{row["vehicleUuid"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: <>Deployment Date</>,
      selector: (row) => row["deploymentDateFormatted"],
      cell: (row) => <span>{row["deploymentDateFormatted"] || "N/A"}</span>,
      sortable: true,
      width: "130px",
    },
    {
      name: "Latitude",
      selector: (row) => row["scannedLatitude"],
      cell: (row) => <span>{row["scannedLatitude"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Longitude",
      selector: (row) => row["scannedLongitude"],
      cell: (row) => <span>{row["scannedLongitude"] || "N/A"}</span>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Deployment Image",
      cell: (row) => {
        if (row["vehicleImageUrl"]) {
          return (
            <img
              src={row["vehicleImageUrl"]}
              alt="Vehicle"
              style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px", cursor: "pointer" }}
              onClick={() => handleImageClick(row.vehicleImageUrl)}
            />
          );
        } else {
          return <span>No image</span>;
        }
      },
      sortable: true,
      width: "120px",
    },
  ];

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleClose = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  const exportToExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `Vehicle Wise Reported SCVs Circle on ${fromDate ? formatDateTimeWithoutSec(fromDate) : getCurrentISTDate()} to ${toDate ? formatDateTimeWithoutSec(toDate) : getCurrentISTDate()} (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    const boldFont = { bold: true };

    const downloadDateTime = `Reported on: ${formattedDate} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont;
    dateTimeRow.getCell(3).alignment = { horizontal: "center" };
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 7);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 10) {
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    worksheet.addRow([""]);

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Number",
      "Vehicle Type",
      "Owner Type",
      "Vehicle Capacity",
      "Vehicle UID",
      "Deployment Date",
      "Latitude",
      "Longitude",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 12) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    scvList.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.wardName ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.vehicleTypeName ?? "N/A",
        item.ownerTypeName ?? "N/A",
        item.vehicleCapacityName ?? "N/A",
        item.vehicleUuid ?? "N/A",
        item.deploymentDateFormatted ?? "N/A",
        item.scannedLatitude ?? "N/A",
        item.scannedLongitude ?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 12) {
          cell.alignment = { horizontal: "left" };
        } else {
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ReportedSCVsCircle.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleBackClick = () => {
    navigate(-1, { state: { from: fromDate, to: toDate } });
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="top-header page-title">
              <span>Vehicle Wise Reported SCVs at Circle on {fromDate ? formatDateTimeWithoutSec(fromDate) : getCurrentISTDate()} to {toDate ? formatDateTimeWithoutSec(toDate) : getCurrentISTDate()} (at {getCurrentDateTime1()})</span>
            </div>
            <div className="page-header"></div>
            <div className="card mt-3">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                  <Formik initialValues={getDefaultFilterFields()}>
                    {({ handleChange, values, resetForm }) => (
                      <Form>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <Field
                                name="searchCircle"
                                placeholder="Search Circle"
                                type="text"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchCircle: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <Field
                                name="searchVehicleNumber"
                                placeholder="Search Vehicle Number"
                                type="text"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchVehicleNumber: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <Field
                                name="searchVehicleUID"
                                placeholder="Search Vehicle UID"
                                type="text"
                                className="form-control bg-white"
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchVehicleUID: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          {/* <div style={{ width: '20%' }}>
                            <div className="form-group">
                              <Field
                                name="searchFromDate"
                                placeholder="From Date and Time"
                                type="datetime-local"
                                className="form-control bg-white"
                                min={minDateTime}
                                max={maxDateTime}
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchFromDate: e.target.value });
                                }}
                              />
                            </div>
                          </div>
                          <div style={{ width: '20%' }}>
                            <div className="form-group">
                              <Field
                                name="searchToDate"
                                placeholder="To Date and Time"
                                type="datetime-local"
                                className="form-control bg-white"
                                min={minDateTime}
                                max={maxDateTime}
                                onInput={(e) => {
                                  handleChange(e);
                                  searchReportedAtVehicleHandler({ ...values, searchToDate: e.target.value });
                                }}
                              />
                            </div>
                          </div> */}
                        </div>
                      </Form>
                    )}
                  </Formik>
                  <div className="d-flex">
                    <button className="btn btn-secondary me-2" onClick={handleBackClick}>
                      Back
                    </button>
                    <button className="btn btn-excel" onClick={exportToExcel}>
                      <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
                <CustomDataTable
                  data={scvList}
                  columns={scvReportColumns}
                  pagination
                  dataPerPage={dataPerPage}
                  currentPage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Image Full Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={selectedImage} alt="Full vehicle" style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SCVDeployedTripsView;